import { render, staticRenderFns } from "./DeliverCtrl.vue?vue&type=template&id=735a91e3&"
import script from "./DeliverCtrl.vue?vue&type=script&lang=js&"
export * from "./DeliverCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports